import React from 'react';
import LandingPageLayout from "../layout/LandingPageLayout";
import LandingPageHowToProfitWidget from "./LandingPageHowToProfitWidget";

import * as icone_1 from "../../../../img/landing-page/icone-01.svg";
import * as icone_2 from "../../../../img/landing-page/icone-02.svg";
import * as icone_3 from "../../../../img/landing-page/icone-03.svg";
import * as icone_4 from "../../../../img/landing-page/icone-04.svg";
import * as icone_5 from "../../../../img/landing-page/icone-05.svg";
import * as icone_6 from "../../../../img/landing-page/icone-06.svg";
import LandingPageSectionTitle from './LandingPageSectionTitle';

const LandingPageHowToProfit = () => {
    const helpData = [
        {
            title: 'Aproveite as milhas que você já tem.',
            icon: icone_1,
            aboutText: "Milhas são algo que muita gente tem e às vezes não sabe. Se você faz compras no cartão de crédito ou já viajou de avião, provavelmente tem milhas acumuladas. É só aproveitar."
        },
        {
            title: 'Cadastre-se em um programa de fidelidade.',
            icon: icone_2,
            aboutText: "As companhias aéreas têm programas de fidelidade que permitem o acúmulo de milhas. Os quatro programas nacionais são Multiplus (Latam), Smiles (Gol) e Tudo Azul (Azul)."
        },
        {
            title: 'Aumente suas chances de acumular milhas.',
            icon: icone_3,
            aboutText: "Você pode acumular milhas na assinatura de clubes de vantagens e em bônus que você recebe por comprar em lojas parceiras. Pra valer a pena, a dica é aproveitar as promoções de transferência de pontos para ganhar bônus e acelerar o acúmulo de milhas."
        },
        {
            title: 'Confira a validade das milhas e não deixe que elas expirem.',
            icon: icone_4,
            aboutText: "Você sabia que o valor das suas milhas está embutindo em cada compra que faz no cartão de crédito ou na aquisição de produtos e serviços de parceiros dos programas de fidelidade? Por isso, deixá-las expirar é o mesmo que jogar dinheiro fora."
        },
        {
            title: 'Vender milhas é fácil, prático e seguro.',
            icon: icone_6,
            aboutText: "A MaxMilhas é especializada na emissão de passagens aéreas com milhas e intermedia todo o processo de venda das suas milhas. Você só precisa fazer sua oferta na plataforma e pronto!"
        },
        {
            title: 'Faça dinheiro com suas milhas.',
            icon: icone_5,
            aboutText: "Você pode vender suas milhas e ganhar um bom dinheiro com elas. Esse é um tipo de investimento que tem gerado mais lucro do que qualquer outro. Então, não perca mais tempo!"
        }
    ]

    return (
        <LandingPageLayout classAdd='offers-landing-page-how-to-profit'>
            <LandingPageSectionTitle strongText="Você pode lucrar" text="com a venda de suas milhas" />
            <div className="offers-landing-page-how-to-profit__helps">
                {
                    helpData.map((widget, index) =>
                        <LandingPageHowToProfitWidget
                            key={index}
                            number={index + 1}
                            title={widget.title}
                            icon={widget.icon}
                            aboutText={widget.aboutText}
                        />
                    )
                }
            </div>
        </LandingPageLayout>
    );
};

export default LandingPageHowToProfit;